module.exports = __webpack_public_path__ + "static/media/add.02ec7f27.svg";